import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, GraduationCap, Sparkles } from "lucide-react";

// Wielki banner kampanii wirtualnych korepetytorów (sekcja Aplikacje)
export function TutorCampaign() {
  const ref = useRef(null);
  const [shift, setShift] = useState({ x: 0, y: 0 });

  const onMove = (e) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    setShift({
      x: ((e.clientX - rect.left) / rect.width - 0.5) * 18,
      y: ((e.clientY - rect.top) / rect.height - 0.5) * 12,
    });
  };

  return (
    <section className="relative mx-auto max-w-7xl px-4 pb-6 sm:px-6" data-testid="tutor-campaign">
      <div
        ref={ref}
        onMouseMove={onMove}
        onMouseLeave={() => setShift({ x: 0, y: 0 })}
        className="group relative overflow-hidden rounded-[2rem] border border-cyan-400/25 shadow-[0_30px_90px_-30px_rgba(34,211,238,0.45)]"
      >
        <div className="relative">
          <img
            src="/img/banners/tutor-campaign.jpg"
            alt="Wirtualni korepetytorzy DigiTutor"
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out will-change-transform group-hover:scale-[1.05]"
            style={{ transform: `translate(${shift.x}px, ${shift.y}px) scale(1.07)` }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-950/90 via-slate-950/55 to-slate-950/15" />
          <div className="relative flex min-h-[26rem] flex-col justify-center px-6 py-10 sm:px-12">
            <span className="flex w-fit items-center gap-1.5 rounded-full bg-gradient-to-r from-cyan-400 to-fuchsia-400 px-4 py-1.5 text-[10px] font-bold uppercase tracking-widest text-slate-950 shadow-lg">
              <Sparkles className="h-3 w-3" /> Nowość — Wirtualni Korepetytorzy
            </span>
            <h3 className="mt-4 max-w-xl font-display text-3xl font-extrabold leading-tight text-white sm:text-4xl lg:text-5xl">
              Prywatna lekcja 1-na-1,<br />kiedy tylko chcesz
            </h3>
            <p className="mt-3 max-w-md text-sm text-slate-200 [text-shadow:0_2px_14px_rgba(2,6,23,.9)] sm:text-base">
              Rozmawiaj głosem lub na czacie, ucz się we własnym tempie — od Twojego poziomu,
              poznawanego na inteligentnym teście startowym. Dla Ciebie i dla Twojego dziecka.
              Bez abonamentu — kupujesz raz, masz na zawsze.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/produkt/digitutor-ai"
                data-testid="tutor-campaign-adult"
                className="group/btn flex items-center gap-2 rounded-full bg-gradient-to-r from-cyan-500 to-teal-400 px-6 py-3 text-sm font-bold text-slate-950 shadow-lg shadow-cyan-500/30 transition-transform hover:scale-105 active:scale-95"
              >
                <GraduationCap className="h-4 w-4" /> DigiTutor AI — dla Ciebie
                <ArrowRight className="h-4 w-4 transition-transform group-hover/btn:translate-x-1" />
              </Link>
              <Link
                to="/produkt/digitutor-kids"
                data-testid="tutor-campaign-kids"
                className="group/btn flex items-center gap-2 rounded-full bg-gradient-to-r from-fuchsia-500 to-pink-400 px-6 py-3 text-sm font-bold text-slate-950 shadow-lg shadow-fuchsia-500/30 transition-transform hover:scale-105 active:scale-95"
              >
                🤖 DigiTutor Kids — dla dziecka
                <ArrowRight className="h-4 w-4 transition-transform group-hover/btn:translate-x-1" />
              </Link>
            </div>
            <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-1 text-[11px] font-semibold text-cyan-200/90">
              <span>✓ Test poziomujący na start</span>
              <span>✓ Rozmowa głosem i na czacie</span>
              <span>✓ 299 zł raz — na zawsze</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
